import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/(admin-dashboard)/admin/_dashboard',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_authenticated/(admin-dashboard)/admin/_dashboard"!</div>
}
